// extracted by mini-css-extract-plugin
module.exports = {"item":"Item10_item__TO8oO","active":"Item10_active__2PSVz","head":"Item10_head__2ghRA","body":"Item10_body__3grvO","button":"Item10_button___d5qK"};